import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-offic-9",
  "use": "icon-ie-offic-9-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-offic-9\">\r\n    <path d=\"M224.109714 168.740571a119.515429 119.515429 0 0 1 115.053715-83.382857h345.673142c53.174857 0 100.059429 33.938286 115.053715 83.382857l176.493714 581.046858c22.674286 74.459429-34.962286 149.065143-115.053714 149.065142H162.669714c-80.091429 0-137.654857-74.605714-115.053714-149.065142l176.493714-581.046858z\" fill=\"#1890FF\" p-id=\"2566\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol